import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
import { PedagogieRoles } from "@inspire/data/static/pedagogie";
import { Academies } from "@inspire/data/static/academies";
import { Bacs2019 } from "@inspire/data/static/static";
var PedagogieProfileSchema = new SimpleSchema({
    lyceeIds: {
        type: Array,
        label: "Etablissements",
        optional: true,
        autoform: {
            type: "list-editor"
        }
    },
    "lyceeIds.$": {
        type: String,
        optional: true
    },
    fonction: {
        type: String,
        optional: true,
        autoform: {
            options: PedagogieRoles
        }
    },
    pedagogie_filiere: {
        type: Array,
        optional: true,
        minCount: 1,
        question: {
            isAnswered: function(data) {
                (data === null || data === void 0 ? void 0 : data.pedagogie_filiere.length) > 0;
            }
        }
    },
    "pedagogie_filiere.$": {
        type: String,
        optional: true,
        allowedValues: Object.keys(Bacs2019)
    },
    fonctionAutre: {
        type: String,
        optional: true
    },
    bookmarkedEleves: {
        type: Array,
        optional: true
    },
    "bookmarkedEleves.$": {
        type: String,
        optional: true
    },
    academie: {
        type: String,
        optional: true,
        autoform: {
            options: Academies
        }
    },
    lastBookmarkDate: {
        type: Date,
        optional: true
    }
});
export { PedagogieProfileSchema };
